import React from "react";
import { useTranslation } from "react-i18next";
import { OrderStatus } from "../../../types/enum/orderStatus";
import { Order } from "../../../types/modules/order.type";
import { Link } from "react-router-dom";
import DateTimeText from "../../ui/DateTimeText";
import { formatNumber } from "../../../utils/formatNumber";
import PriceText from "../../ui/PriceText";

interface Props {
  orders: Order[];
}

const OrdersTable: React.FC<Props> = ({ orders }) => {
  const { t } = useTranslation();

  console.log(orders);
  
  return (
    <div className="overflow-x-auto">
      <table className="w-full border-separate border-spacing-y-5">
        <thead>
          <tr className="text-start text-sm text-DarkGrey2 font-semibold">
            <th className="p-3 font-normal">{t("customerName/orderNo")}</th>
            <th className="p-3 font-normal">{t("dateTime")}</th>
            <th className="p-3 font-normal">{t("pickupMethod")}</th>
            <th className="p-3 font-normal">{t("prepTime")}</th>
            <th className="p-3 font-normal">{t("items")}</th>
            <th className="p-3 font-normal">{t("price")}</th>
            <th className="p-3 font-normal">{t("status")}</th>
            <th className="p-3 font-normal">{t("actions")}</th>
          </tr>
        </thead>
         <tbody className="text-sm">
          {orders.map((order) => (
            <tr
              key={order.orderNumber}
              className="bg-white rounded-[12px]"
              style={{ boxShadow: "0px 4px 32px rgba(86, 92, 120, 0.08)" }}
            >
              {/* Customer Image + Name + Order No */}
              <td className="p-3 flex items-center gap-3 min-w-[250px]">
                <div>
                  <img
                    src={order.customer.imageUrl ? order.customer.imageUrl : order.customer.avatar?.url||""}
                    alt={order.customer.name}
                    className="w-14 h-14 rounded-full object-cover"
                  />
                </div>
                <div className="flex flex-col">
                  <span className="text-Black mb-1 font-black text-[12px]">{order.customer.name}</span>
                  <span className="text-DarkGrey3 font-semibold text-[12px]">#{formatNumber(order.orderNumber)}</span>
                </div>
              </td>

              {/* Date & Time */}
              <td className="p-3 min-w-[150px] text-DarkGrey2 font-semibold">
                <DateTimeText date={order.createdAt}/>
              </td>
              {/* Pickup Method */}
              <td className="p-3 min-w-[120px] text-Black font-semibold">{t(order.pickupType)}</td>

              {/* Prep Time */}
              <td className="p-3 min-w-[80px] text-DarkGrey3 font-black">{formatNumber(order.estimatedTime)} {t('mins')}</td>

              {/* Items */}
              <td className="p-3 min-w-[80px] text-DarkGrey3 font-black"><span>x</span>{formatNumber(order.productCount)} <span> {t("item")}</span></td>

              {/* Price */}
              <td className="p-3 min-w-[100px] text-DarkGrey3 font-black">
               <div className=" flex items-center gap-1">
                 <img src="/Vector2.png"  className="w-[10.67px] h-[11.95px]" alt=""/>
                <PriceText value={order.finalPriceToPay}/>
               </div>
              </td>

              {/* Status */}
              <td className="p-3 min-w-[120px]">
                {order.status === OrderStatus.received ? (
                  <span className="px-2 py-2 flex items-center justify-center rounded-tl-[20px] rounded-tr-[8px] rounded-br-[20px] rounded-bl-[8px] w-[96px] text-xs bg-primaryButton text-white">
                    {t("completed")}
                  </span>
                ) : (order.status === OrderStatus.cancelled || order.status===OrderStatus.expired_confirmation || order.status===OrderStatus.rejected) ? (
                  <span className="px-2 py-2 flex items-center justify-center rounded-tl-[20px] rounded-tr-[8px] rounded-br-[20px] rounded-bl-[8px] w-[96px] text-xs bg-Red text-white">
                    {t("cancelled")}
                  </span>
                ) : (
                  <span className="px-2 py-2 flex items-center justify-center rounded-tl-[20px] rounded-tr-[8px] rounded-br-[20px] rounded-bl-[8px] w-[96px] text-xs bg-yellow-500 text-white">
                    {t(order.status)}
                  </span>
                )}
              </td>
              <td className=" p-3 text-center text-Black font-bold underline">
                <Link to={`${order.id}`}>{t('view')}</Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default OrdersTable;
